import { ORDER_ADD, ORDER_PAID, ORDER_CLOSE, ORDER_SYNC, PAYMENT_ADD, CALCULATE_CHANGE, GET_CLOSED_ORDERS, ORDERS_RESET } from '../actions/index';
import moment from 'moment';

export default function(state = {}, action) {
  switch(action.type) {
    case ORDER_ADD:
      return {
        ...state,
        [action.id]: {
          id: action.id,
          server_id: 'Syncing',
          order_time_start: moment().format('YYYY-MM-DD HH:mm:ss'),
          order_paid: 0,
          order_status: 'NEW',
          order_pay_location: 'STORE',
          order_location: 'DINEIN',
          order_synced: false,
          updated: '',
          ...action.order
        },
      }
    case ORDER_PAID:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          order_paid: 1,
        },
      }
    case ORDER_CLOSE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          order_status: 'CLOSED',
          order_time_close: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
      }
    case ORDER_SYNC:
      return {
        ...state,
        [action.localId]: {
          ...state[action.localId],
          order_synced: true,
          server_id: action.serverId,
          updated: action.updated,
        },
      }
    case PAYMENT_ADD:
      return {
        ...state,
        [action.orderID]: {
          ...state[action.orderID],
          payments: {
            ...state[action.orderID].payments,
            [action.id]: {
              payments_id: action.id,
              type: action.paymentType,
              amount: action.paymentAmount,
              payment_paid: moment().format('YYYY-MM-DD HH:mm:ss')
            }
          }
        }
      }
    case CALCULATE_CHANGE:
      // Calculate change for the order
      let order_change = parseFloat((action.paymentsTotal - state[action.id].grandtotal).toFixed(2), 10);

      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          change: order_change,
        },
      }
    case GET_CLOSED_ORDERS:
      return {
        ...state,
        ...action.payload,
      }
    case ORDERS_RESET:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_orders.js